// @ts-nocheck
import axios from 'axios';
import { useCallback } from 'react';

import API_ENDPOINTS from '../../const/ApiEndPoints';
import useTask from './useTask';

export default function useDashboard() {
  const {
    getPendingTasks,
    getOpenTasks,
    getTaskQueue,
    getTaskResult,
    retriggerAutomation,
  } = useTask();

  const getNodesEdges = useCallback((params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_NODES}`,
        {
          params,
          loader: false,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getFiles = useCallback(() => {
    return axios
      .get(`${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.BU.GET_FILES}`)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getFilter = useCallback(
    (entityType = '', requestType = '', loader = true) => {
      let params = { entityType };
      if (requestType) {
        params.requestType = requestType;
      }
      return axios
        .get(
          `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_FILTER}`,
          {
            params,
            loader,
          }
        )
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
    []
  );
  const getAllSavedSearches = useCallback(() => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_ALL_SAVED_SEARCH}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getFilterList = useCallback((body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_FILTERED_DATA}`,
        {
          params: body,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getAlertData = useCallback((body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_ALERTS}`,
        {
          params: {
            pageIndex: body?.pageIndex,
            pageSize: body?.pageSize,
          },
          loader: body?.isLoading,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getPipelineData = useCallback((body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.PIPELINE}`,
        {
          params: {
            pageIndex: body?.pageIndex,
            pageSize: body?.pageSize,
          },
          loader: body?.isLoading,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const getDashboardReports = useCallback(() => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.DASHBOARD_REPORTS}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const updateAlert = useCallback((body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.UPDATE_ALERT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getAllEvents = useCallback((body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.ALL_EVENTS}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);
  const getKibanDashboard = useCallback((body) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.GET_KIBAN_DASHBOARD}`,
        { params: body }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const getEventsCount = useCallback((body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.DB.EVENTS_COUNT}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const downloadConnectivityReport = useCallback((body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.DOWNLOAD_CONNECTIVITY_REPORT}`,
        body,
        {
          responseType: 'arraybuffer', // Set responseType to 'arraybuffer' to handle binary data
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  return {
    getFilter,
    getFilterList,
    getNodesEdges,
    getFiles,
    getAlertData,
    getDashboardReports,
    updateAlert,
    getAllEvents,
    getPipelineData,
    getKibanDashboard,
    getEventsCount,
    getPendingTasks,
    getOpenTasks,
    getTaskQueue,
    getTaskResult,
    getAllSavedSearches,
    downloadConnectivityReport,
    retriggerAutomation,
  };
}
